import {combineReducers} from 'redux';
import pageReducer from './pageReducer';
// import data from './dataReducer';

export default combineReducers({
  views: combineReducers({
    tasks: pageReducer, // we may have more pages here
  }),
});
